export const STATUS_TASK = {
  pendente: { label: 'Pendente', color: '#F59E0B' },
  em_andamento: { label: 'Em Andamento', color: '#3B82F6' },
  aguardando: { label: 'Aguardando', color: '#6B7280' },
  concluida: { label: 'Concluída', color: '#10B981' },
  atrasada: { label: 'Atrasada', color: '#EF4444' },
  cancelada: { label: 'Cancelada', color: '#6B7280' },
} as const;

export const STATUS_PROJECT = {
  ativo: { label: 'Ativo', color: '#3B82F6' },
  pausado: { label: 'Pausado', color: '#F59E0B' },
  concluido: { label: 'Concluído', color: '#10B981' },
  cancelado: { label: 'Cancelado', color: '#6B7280' },
} as const;

export const PRIORIDADES = {
  baixa: { label: 'Baixa', color: '#6B7280' },
  media: { label: 'Média', color: '#3B82F6' },
  alta: { label: 'Alta', color: '#F59E0B' },
  urgente: { label: 'Urgente', color: '#EF4444' },
} as const;

export const PERMISSOES = {
  admin: 'Administrador',
  gestor: 'Gestor',
  colaborador: 'Colaborador',
} as const;

export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';
